import React from "react";

const SECTORS = [
  "Manufactura automotriz",
  "Maquiladoras",
  "Parques industriales",
  "Industria metalmecánica",
  "Logística y centros de distribución",
  "Plantas alimenticias",
  "Industria química",
  "Data centers",
  "Energía y utilities",
];

const PARKS = [
  "Parque Industrial Derramadero",
  "Parque Industrial Ramos Arizpe",
  "Parque Industrial Saltillo Sur",
  "Parque Industrial La Angostura",
  "Parque Industrial Santa María",
  "Parque Industrial Amistad",
];

export const Sectors = () => {
  return (
    <section
      id="sectores"
      data-testid="sectors-section"
      className="relative py-24 lg:py-32 border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 reveal">
            <span className="section-tag">04 / Sectores · Clientes</span>
            <h2 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-[56px] tracking-tight leading-[0.98]">
              Operamos en el corazón de la{" "}
              <span className="text-[#F8BC33]">industria coahuilense</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 reveal reveal-delay-1">
            <p className="text-white/65 leading-relaxed">
              Desde plantas armadoras tier-1 hasta maquiladoras de electrónica,
              acompañamos a empresas que no pueden permitirse un minuto de
              paro.
            </p>
          </div>
        </div>
      </div>

      {/* Sectors marquee */}
      <div className="relative reveal" data-testid="sectors-marquee">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#181C24] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#181C24] to-transparent z-10 pointer-events-none" />
        <div className="flex overflow-hidden border-y border-white/10 py-8">
          <div className="marquee-track flex shrink-0 items-center gap-14 pr-14">
            {[...SECTORS, ...SECTORS].map((s, i) => (
              <span
                key={i}
                className="flex items-center gap-6 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white/80 whitespace-nowrap"
              >
                {s}
                <span className="text-[#F8BC33]">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Parks */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4 reveal">
            <h3 className="font-display font-bold text-2xl lg:text-3xl">
              Presencia en parques industriales
            </h3>
            <p className="mt-4 text-white/60 leading-relaxed text-sm">
              Más de 200 sitios atendidos en los principales desarrollos
              industriales de Coahuila.
            </p>
          </div>
          <div className="lg:col-span-8">
            <ul className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
              {PARKS.map((p, i) => (
                <li
                  key={p}
                  className="bg-[#181C24] hover:bg-[#212731] transition-colors px-6 py-5 flex items-center justify-between group reveal"
                  data-testid={`park-${i}`}
                >
                  <span className="text-white/85">{p}</span>
                  <span className="font-mono-tech text-[10px] tracking-widest text-white/35 group-hover:text-[#F8BC33] transition-colors">
                    ACTIVO
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sectors;
